import { FadeIn } from "../motion/Reveal";
import { PLATFORMS } from "../../data/content";

export const PlatformLogos = () => {
  return (
    <section
      id="platforms"
      data-testid="platforms-section"
      className="relative py-24 md:py-28 px-6 md:px-10 bg-[#050505] border-y border-white/10 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-60 bg-[radial-gradient(circle_at_78%_20%,rgba(255,69,0,0.15),transparent_28%),linear-gradient(180deg,rgba(255,255,255,0.03),transparent)]" />
      <div className="relative z-10 max-w-[1400px] mx-auto">
        <FadeIn>
          <h2
            data-testid="platforms-heading"
            className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight"
          >
            Platforms that work with us
          </h2>
        </FadeIn>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 border-y border-white/10">
          {PLATFORMS.map((platform, index) => (
            <FadeIn
              key={platform.name}
              delay={index * 0.08}
              data-testid={`platform-logo-card-${index + 1}`}
              className={`group min-h-[260px] md:min-h-[360px] p-8 md:p-12 flex flex-col items-center justify-center text-center bg-white/[0.015] transition-[background-color,transform] duration-500 hover:bg-white/[0.045] ${
                index < PLATFORMS.length - 1
                  ? "border-b md:border-b-0 md:border-r border-white/10"
                  : ""
              }`}
            >
              <div className="flex h-40 w-40 md:h-48 md:w-48 items-center justify-center rounded-3xl border border-white/10 bg-black/35 p-6 md:p-7 shadow-[0_30px_80px_-38px_rgba(0,0,0,0.95)]">
                <img
                  src={platform.logo}
                  alt={`${platform.name} logo`}
                  data-testid={`platform-logo-image-${index + 1}`}
                  className="max-h-full max-w-full object-contain transition-[filter,transform] duration-500 group-hover:scale-105"
                />
              </div>
              <div className="mt-6 md:mt-8">
                <h3
                  data-testid={`platform-logo-name-${index + 1}`}
                  className="font-display text-lg md:text-xl font-semibold text-white tracking-tight"
                >
                  {platform.name}
                </h3>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};